import React from 'react';

interface Props {
  visible: boolean;
}

const DeliveryCoordinatesWarning = ({ visible }: Props) => {
  if (!visible) return null;

  return (
    <div
      className="bg-red w-full flex justify-center text-white py-2 px-4 text-lg font-semibold"
      role="alert"
    >
      Attention : les coordonnées de l’adresse de livraison sont manquantes.
    </div>
  );
};

export default DeliveryCoordinatesWarning;
